import React, { Component } from 'react';
import classNames from 'classnames';
import Markdown from 'markdown-to-jsx';
import { PaddedSection, Button } from '../../atoms';
import './styles.css';
import ContentConverter from '../../../utils/contentConverter';
import { Link } from 'react-router-dom';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} buttonLabel
 * @prop {String} content
 * @prop {String} heading
 * @prop {String} subheading
 * @prop {String} [className]
 * @prop {function} [href]
 *
 * @augments {Component<Props>}
 */
export default class TaggisAndDocBrowser extends Component {

	genClassName = (props) => classNames('TaggisAndDocBrowser', props.className);

	/**
	 * @param {String} content
	 */
	getContent = (content) => new ContentConverter(content).convertLinks(true).nlToBr().getHtml();

	render () {
		const {
			buttonLabel,
			content,
			heading,
			href,
			subheading,
		} = this.props;
		return (
			<PaddedSection className={this.genClassName(this.props)}>
				<div className='TaggisAndDocBrowser-image' />
				<div className='TaggisAndDocBrowser-content'>
					{subheading ? <h2>{subheading}</h2> : null}
					<h1>{heading}</h1>
					<p>
						<Markdown
							options={{
								overrides: {
									Link: {
										component: Link,
									},
								},
							}}
						>{this.getContent(content)}</Markdown>
					</p>
					<Button className='TaggisAndDocBrowser-button' href={href}>
						<span>{buttonLabel}</span>
					</Button>
				</div>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/TaggisAndDocBrowser/TaggisAndDocBrowser.js